import React from 'react';
import './Contact.css';
import outside from '../../assets/images/office-outside-img.png';
import inside from '../../assets/images/office-inside-img.png';
import logo from '../../assets/images/styx-logo.png';

export default function Contact() {
  return (
    <section id="contact" className="contact-section" aria-labelledby="contact-heading">
      <h2 id="contact-heading" className="contact-heading">Contact</h2>

      <div className="contact-grid">
        <div className="contact-image" aria-hidden="true">
          <img src={outside} alt="Office building exterior" />
        </div>

        <aside className="contact-card" aria-labelledby="company-name">
          <div className="card-header">
            <img src={logo} alt="Styx logo" className="company-logo" />
          </div>
          <div id="company-name" className="company-name">Styx Biotechnologies Inc</div>
          <div className="contact-details">
            9276 Scranton Rd,<br />
            Suite 500<br />
            San Diego, CA 92121
          </div>

          <div className="contact-person">
            Ashutosh Tiwari, PhD<br />
            Co-founder & CEO<br />
            <a href="mailto:ashutosh@styxtech.bio">ashutosh@styxtech.bio</a><br />
            (612) 819-7219
          </div>
        </aside>
      </div>

      {/* <div className="office-inside" aria-hidden="true">
        <img src={inside} alt="Office interior" style={{ width: '100%', display: 'block' }} />
      </div> */}
    </section>
  );
}

